<style lang="scss">
.delete-dialog-card {
  padding: 20px;
  .headline {
    font-size: 14px !important;
    margin-bottom: 20px;
  }
  button {
    font-size: 14px;
    &.close-dialog {
      border: solid 1px #173d8f;
      color: #173d8f;
    }
    &.delete {
      background-color: #d9390d;
      background: #d9390d!important;
      color: #ffffff;
    }
  }
}
</style>

<template>
  <v-dialog v-model="deleteDialog" :max-width="maxWidth || 325" :persistent="persistent">
    <v-toolbar class="toolbar-update" dense >
      <v-toolbar-title class="text-primary fs-15">
        <strong>{{$t('NOTIFICATION')}}</strong>
      </v-toolbar-title>
    </v-toolbar>
    <div class="content-update">
      <label class="s-label"><slot name="title" /></label>
      <div class="mt-3 d-flex justify-content-between">
        <div class="w-100 mr-1">
          <v-btn depressed block @click="close">
            {{ $t("_LOGIN.CANCEL") }}
          </v-btn>
        </div>
        <div class="w-100 ml-1">
          <v-btn block color="primary" @click="deleteItem">
            {{ $t("CONFIRM") }}
          </v-btn>
        </div>
      </div>
    </div>
    <!-- <v-card class="delete-dialog-card">
      <slot name="title" />
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn depressed class="close-dialog mr-5 pl-3 pr-3" @click="close">
          {{ $t("CLOSE") }}
        </v-btn>
        <v-btn color="" class="delete pl-5 pr-5" @click="deleteItem">{{ $t("CONFIRM") }}</v-btn>
      </v-card-actions>
    </v-card> -->
  </v-dialog>
</template>

<script>
export default {
  props: {
    maxWidth: Number,
    persistent: Boolean
  },
  data() {
    return {
      deleteDialog: false,
      item: null
    };
  },
  methods: {
    open(item) {
      this.deleteDialog = true;
      this.item = item;
    },
    close() {
      this.$emit("cancelDelete", this.item);
      this.deleteDialog = false;
    },
    deleteItem() {
      this.$emit("deleteItem", this.item);
      this.deleteDialog = false;
    }
  }
};
</script>
